import React from 'react'
import { getSession, getMerchantId } from '../../utils/api'
import { mfeConfigs } from '../../utils/mfe'
import { SingleSpaParcel } from './SingleSpaParcel'
import { RouteConstants } from '../../utils/constants'
import { isArray } from 'lodash'

const origin = 'blu'

export const SystemActivityLogPage = (props) => {
  const session = getSession()
  const authToken = session && session.accessToken
  const shops =
    session &&
    session.shops &&
    isArray(session.shops) &&
    session.shops.map((shop) => ({ id: shop.id, name: shop.name }))
  const merchantId = getMerchantId()
  return (
    <SingleSpaParcel
      {...props}
      basename={RouteConstants.SYSTEM_ACTIVITY_LOGS().BASE}
      authToken={authToken}
      origin={origin}
      merchantId={merchantId}
      shops={shops}
      config={mfeConfigs.LOAD_SYSTEM_ACTIVITY_LOG_PAGE}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/MfeParcels/SystemActivityLogPage.js